import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const DelayRender = ({ children, waitBeforeShow = 500 }) => {
  const [isShown, setIsShown] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsShown(true);
    }, waitBeforeShow);

    return () => clearTimeout(timer);
  }, [waitBeforeShow]);

  return isShown ? children : null;
};
DelayRender.propTypes = {
  children: PropTypes.element.isRequired,
  waitBeforeShow: PropTypes.number,
};
export default DelayRender;
